import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

const validateUrl = (url) => {
  try {
    const u = new URL(url);
    return u;
  } catch (err) {
    return false;
  }
};

const ajaxCall = async (postId = "", container, actionName) => {
  if (!universityPressThemeSettings.wordpressAjaxUrl) {
    return;
  }
  const ajaxUrl = validateUrl(universityPressThemeSettings.wordpressAjaxUrl);
  if (!ajaxUrl) {
    return;
  }

  ajaxUrl.searchParams.set("action", actionName);
  if (postId) {
    ajaxUrl.searchParams.set("postId", postId);
  }

  const response = await fetch(ajaxUrl);
  if (!response.ok) {
    return;
  }

  Object.assign(container, { innerHTML: await response.text() });
};

const articleContent = async () => {
  const articleContainers = document.querySelectorAll(".js-article-content");

  await Promise.all(
    [...articleContainers].map((container) => {
      if (!container.dataset.postId) {
        return;
      }

      return ajaxCall(
        container.dataset.postId,
        container,
        "monthly_ajax_article_content",
      );
    }),
  );
};

document.addEventListener("DOMContentLoaded", async () => {
  await articleContent();

  const images = document.querySelectorAll(
    ".article__content img:not(.attachment-full):not(.emoji)",
  );

  if (images.length > 0) {
    images.forEach((img) => {
      // Skip if already wrapped
      if (img.parentElement.tagName.toLowerCase() === "a") {
        const link = img.parentElement;
        const nextElement = link.nextElementSibling;
        link.classList.add("glightbox");
        let caption = img.alt || "";

        if (nextElement && nextElement.tagName.toLowerCase() === "figcaption") {
          caption = nextElement.innerHTML;
        }

        link.setAttribute("data-glightbox", `description:${caption}`);
      } else {
        // If not wrapped in <a>, wrap dynamically
        const wrapper = document.createElement("a");
        wrapper.href = img.src;
        wrapper.classList.add("glightbox");
        wrapper.setAttribute("data-glightbox", `description:${img.alt || ""}`);

        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
      }
    });
  }

  const lightbox = GLightbox();

  const allPostItems = document.querySelectorAll(
    ".article__header--topics--place",
  );

  if (allPostItems.length === 0) return;

  allPostItems.forEach((post) => {
    const allItems = post.querySelectorAll(".topics__list > .cat-item");
    if (allItems.length === 0) return;
    allItems.forEach((list) => {
      const allSubItems = list.querySelectorAll("li");
      const lastItem = allSubItems[allSubItems.length - 1];
      if (lastItem) {
        lastItem.querySelector("a").classList.add("last");
      }
    });
  });
});
